import { render, staticRenderFns } from "./Checkmark.vue?vue&type=template&id=ae89150a&scoped=true"
import script from "./Checkmark.vue?vue&type=script&lang=js"
export * from "./Checkmark.vue?vue&type=script&lang=js"
import style0 from "./Checkmark.vue?vue&type=style&index=0&id=ae89150a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae89150a",
  null
  
)

export default component.exports